class BasicHeader extends HTMLElement {
  constructor() {
    super();
  }

  get headerSection() {
    return document.querySelector('.header-section');
  }

  get enableTransparent() {
    return this.dataset.enableTransparent === 'true';
  }

  connectedCallback() {
    this.init();

    if (window.ResizeObserver) {
      new ResizeObserver(this.setHeight.bind(this)).observe(this);
    }

    if (Shopify.designMode) {
      const section = this.closest('.shopify-section');

      if (section) {
        section.addEventListener(
          'shopify:section:load',
          this.init.bind(this)
        );

        section.addEventListener(
          'shopify:section:unload',
          this.init.bind(this)
        );

        section.addEventListener(
          'shopify:section:reorder',
          this.init.bind(this)
        );
      }
    }
  }


  init() {
    new FoxTheme.delayUntilInteraction(
      this.setHeight.bind(this)
    );

    if (this.enableTransparent && this.headerSection) {
      this.headerSection.classList.add(
        'header-transparent'
      );
    }
  }


  setHeight() {

    requestAnimationFrame(() => {

      const offsetHeight = Math.round(
        this.offsetHeight
      );

      const offsetTop = Math.round(
        this.parentElement?.offsetTop || 0
      );


      document.documentElement.style.setProperty(
        '--header-height',
        `${offsetHeight}px`
      );


      document.documentElement.style.setProperty(
        '--header-offset-top',
        `${offsetTop}px`
      );

    });

  }
}


customElements.define(
  'basic-header',
  BasicHeader,
  {
    extends:'header'
  }
);



class StickyHeader extends BasicHeader {

  constructor() {

    super();

    this.classes = {
      pinned:'header-pinned'
    };

  }


  get isAlwaysSticky() {

    return this.dataset.stickyType === 'always';

  }


  connectedCallback(){

    super.connectedCallback();

    this.currentScrollTop = 0;

    this.firstScrollTop = window.scrollY;

    this.headerBounds =
      this.headerSection.getBoundingClientRect();


    this.beforeInit();

  }



  beforeInit(){

    this.headerSection.classList.add(
      'header-sticky'
    );


    this.headerSection.dataset.stickyType =
      this.dataset.stickyType;


    window.addEventListener(
      'scroll',
      this.onScrollHandler.bind(this),
      false
    );

  }



  onScrollHandler(){

    const scrollTop = window.scrollY;

    const headerSection =
      this.headerSection;


    requestAnimationFrame(()=>{


      const headerBoundsTop =
        this.headerBounds.top +
        this.firstScrollTop;


      const headerBoundsBottom =
        this.headerBounds.bottom +
        this.firstScrollTop;



      if(scrollTop > headerBoundsTop){


        headerSection.classList.add(
          'header-scrolled'
        );



        if(this.isAlwaysSticky){

          document.body.classList.add(
            this.classes.pinned
          );


        } else {


          if(
            scrollTop < this.currentScrollTop ||
            scrollTop < headerBoundsBottom + 100
          ){

            document.body.classList.add(
              this.classes.pinned
            );


          } else {

            document.body.classList.remove(
              this.classes.pinned
            );

          }

        }



      } else {


        headerSection.classList.remove(
          'header-scrolled'
        );


        document.body.classList.remove(
          this.classes.pinned
        );


      }


      this.currentScrollTop = scrollTop;


    });

  }

}



customElements.define(
  'sticky-header',
  StickyHeader,
  {
    extends:'header'
  }
);
const clearDropdownCount = new WeakMap();
class DetailsDropdown extends HTMLDetailsElement {
  constructor() {
    super();
    // Initialize properties
    this.classes = { bodyClass: 'has-dropdown-menu' };
    this.events = {
      handleAfterHide: 'menu:handleAfterHide',
      handleAfterShow: 'menu:handleAfterShow',
    };

    // Reference to first and last child elements
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;

    // Initial state based on attributes
    this._open = this.hasAttribute('open');

    // Event listeners for summary element
    this.summaryElement.addEventListener('click', this.handleSummaryClick.bind(this));

    if (this.trigger === 'hover') {
      this.summaryElement.addEventListener('focusin', (event) => {
        if (event.target === this.summaryElement) {
          this.open = true;
        }
      });
      this.summaryElement.addEventListener('focusout', (event) => {
        if (!this.contentElement.contains(event.relatedTarget)) {
          this.open = false;
        }
      });
    }

    // Binding methods to ensure 'this' context is correct when they are called
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEscKeyPress = this.handleEscKeyPress.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);

    // Setup hover detection with debouncing
    this.hoverTimer = null;
    this.detectHoverListener = this.detectHover.bind(this);
    this.addEventListener('mouseenter', this.detectHoverListener.bind(this));
    this.addEventListener('mouseleave', this.detectHoverListener.bind(this));
  }

  set open(value) {
    // Check if the new value is different from the current value
    if (value !== this._open) {
      // Update the internal state
      this._open = value;

      // Perform actions based on whether the element is connected to the DOM
      if (this.isConnected) {
        // If connected, perform a transition
        this.transition(value);
      } else {
        // If not connected, directly manipulate the 'open' attribute
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }
    }
  }

  get open() {
    return this._open;
  }

  get trigger() {
    // For touch devices, always use click events
    if (FoxTheme.config.isTouch) {
      return 'click';
    }

    // For non-touch devices, check for custom trigger attribute
    return this.getAttribute('trigger') || 'click';
  }

  get level() {
    if (this.hasAttribute('level')) {
      return this.getAttribute('level');
    } else {
      return 'top';
    }
  }

  handleSummaryClick(event) {
    // Prevent the default action of the event
    event.preventDefault();

    // Check if the device is not touch-enabled and the trigger type is 'hover'
    if (!FoxTheme.config.isTouch && this.trigger === 'hover' && this.summaryElement.hasAttribute('data-link')) {
      // If conditions are met, navigate to the URL specified in 'data-link'
      window.location.href = this.summaryElement.getAttribute('data-link');
    } else {
      // Otherwise, toggle the 'open' state
      this.open = !this.open;
    }
  }

  async transition(value) {
    if (value) {
      // Increment the lock count for dropdowns
      clearDropdownCount.set(DetailsDropdown, clearDropdownCount.get(DetailsDropdown) + 1);

      // Add class to body and set attributes
      document.body.classList.add(this.classes.bodyClass);
      this.setAttribute('open', '');
      this.summaryElement.setAttribute('open', '');
      setTimeout(() => this.contentElement.setAttribute('open', ''), 100);

      // Add event listeners
      document.addEventListener('click', this.handleOutsideClick);
      document.addEventListener('keydown', this.handleEscKeyPress);
      document.addEventListener('focusout', this.handleFocusOut);

      // Perform the transition in animation
      await this.showWithTransition();

      // Check for reverse condition (not implemented here for brevity)
      this.needsReverse();

      // Wait for the after show event
      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
    } else {
      // Decrement the lock count for dropdowns
      clearDropdownCount.set(DetailsDropdown, clearDropdownCount.get(DetailsDropdown) - 1);

      // Toggle class on body based on lock count
      document.body.classList.toggle(this.classes.bodyClass, clearDropdownCount.get(DetailsDropdown) > 0);

      // Remove attributes and event listeners
      this.summaryElement.removeAttribute('open');
      this.contentElement.removeAttribute('open');
      document.removeEventListener('click', this.handleOutsideClick);
      document.removeEventListener('keydown', this.handleEscKeyPress);
      document.removeEventListener('focusout', this.handleFocusOut);

      // Perform the transition out animation
      await this.hideWithTransition();

      // Conditionally remove the 'open' attribute
      if (!this.open) {
        this.removeAttribute('open');
      }

      // Wait for the after hide event
      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
  }

  async showWithTransition() {
    FoxTheme.Motion.animate(
      this.contentElement,
      { opacity: [0, 1], visibility: 'visible' },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.6,
        easing: [0.7, 0, 0.2, 1],
        delay: FoxTheme.config.motionReduced ? 0 : 0.1,
      }
    );
    const translateY = this.level === 'top' ? '-105%' : '2rem';
    return FoxTheme.Motion.animate(
      this.contentElement.firstElementChild,
      { transform: [`translateY(${translateY})`, 'translateY(0)'] },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.6,
        easing: [0.7, 0, 0.2, 1],
      }
    ).finished;
  }

  async hideWithTransition() {
    FoxTheme.Motion.animate(
      this.contentElement,
      { opacity: 0, visibility: 'hidden' },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.3,
        easing: [0.7, 0, 0.2, 1],
      }
    );
    const translateY = this.level === 'top' ? '-105%' : '2rem';
    return FoxTheme.Motion.animate(
      this.contentElement.firstElementChild,
      { transform: `translateY(${translateY})` },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.6,
        easing: [0.7, 0, 0.2, 1],
      }
    ).finished;
  }

  handleOutsideClick(event) {
    const isClickInside = this.contains(event.target);
    const isClickOnDetailsDropdown = event.target.closest('details') instanceof DetailsDropdown;

    if (!isClickInside && !isClickOnDetailsDropdown) {
      this.open = false;
    }
  }

  handleEscKeyPress(event) {
    if (event.code === 'Escape') {
      const targetMenu = event.target.closest('details[open]');
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }

  handleFocusOut(event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.open = false;
    }
  }

  detectHover(event) {
    if (this.trigger === 'hover') {
      this.open = event.type === 'mouseenter';
    }
  }

  needsReverse() {
    const totalWidth = this.contentElement.offsetLeft + this.contentElement.clientWidth * 2;
    if (totalWidth > window.innerWidth) {
      this.contentElement.classList.add('needs-reverse');
    }
  }
}

customElements.define('details-dropdown', DetailsDropdown, { extends: 'details' });
clearDropdownCount.set(DetailsDropdown, 0);

class DetailsMega extends DetailsDropdown {
  constructor() {
    super();
    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', () => {
        this.open = true;
      });

      this.addEventListener('shopify:block:deselect', () => {
        this.open = false;
      });
    }
  }

  async showWithTransition() {
    // Perform the animation on the first child of the content element
    return FoxTheme.Motion.animate(
      this.contentElement.firstElementChild,
      {
        visibility: 'visible',
        transform: ['translateY(-100%)', 'translateY(0)'],
      },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.5,
        easing: [0.39, 0.575, 0.565, 1.0],
      }
    ).finished;
  }

  async hideWithTransition() {
    return FoxTheme.Motion.animate(
      this.contentElement.firstElementChild,
      {
        visibility: 'hidden',
        transform: 'translateY(-100%)',
      },
      {
        duration: FoxTheme.config.motionReduced ? 0 : 0.5,
        easing: [0.39, 0.575, 0.565, 1.0],
      }
    ).finished;
  }
}

customElements.define('details-mega', DetailsMega, { extends: 'details' });

class MenuDrawerDetails extends HTMLDetailsElement {
  constructor() {
    super();

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
  }

  get parent() {
    return this.closest('[data-parent]');
  }

  get summary() {
    return this.querySelector('summary');
  }

  get closeButton() {
    return this.querySelector('button');
  }

  onSummaryClick(event) {
    event.preventDefault();

    this.open = true;
    this.parent?.classList.add('active');
    this.classList.add('active');
    this.summary.setAttribute('aria-expanded', 'true');
  }

  onCloseButtonClick() {
    this.parent.classList.remove('active');
    this.classList.remove('active');
    this.summary.setAttribute('aria-expanded', false);

    this.closeAnimation();
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 240) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer-details', MenuDrawerDetails, { extends: 'details' });

class MenuDrawer extends DrawerComponent {

  constructor() {

    super();

  }


  get menuItems() {

    if (!this._menuItems) {

      this._menuItems =
        this.querySelectorAll(
          '.menu-drawer__menus:not(.active) > li'
        );

    }

    return this._menuItems;

  }


  get requiresBodyAppended() {

    return false;

  }


  prepareToShow(){

    super.prepareToShow();


    setTimeout(()=>{

      this.animateMenuItems();

    },60);

  }


  animateMenuItems(){

    if(FoxTheme.config.motionReduced)
      return;


    FoxTheme.Motion.animate(

      this.menuItems,

      {
        transform:[
          'translateX(-20px)',
          'translateX(0)'
        ],

        opacity:[
          0,
          1
        ]
      },

      {
        duration:0.4,

        easing:[
          0.075,
          0.82,
          0.165,
          1
        ],

        delay:
          FoxTheme.Motion.stagger(0.06)

      }

    ).finished.then(()=>{

      this.menuItems.forEach(
        item =>
          item.removeAttribute('style')
      );

    });

  }


  handleAfterHide(){

    super.handleAfterHide();


    setTimeout(()=>{

      this.querySelectorAll(
        'details[is=menu-drawer-details]'
      )
      .forEach(menu=>{

        menu.onCloseButtonClick();

      });


    });

  }


}


customElements.define(
  'menu-drawer',
  MenuDrawer
);



class MenuProductList extends HTMLElement {


  constructor(){

    super();

    this.initSlide();

    this.elementToFocus =
      this.querySelector('button');

  }



  get container(){

    return this.querySelector('.swiper');

  }


  get sliderPagination(){

    return this.querySelector(
      '.swiper-pagination'
    );

  }


  get sliderNext(){

    return this.querySelector(
      '.swiper-button-next'
    );

  }


  get sliderPrev(){

    return this.querySelector(
      '.swiper-button-prev'
    );

  }


  get numberOfColumns(){

    return parseInt(
      this.dataset.columns
    );

  }


  initSlide(){


    const slider =
      new FoxTheme.Carousel(

        this.container,

        {

          spaceBetween:10,

          slidesPerView:
            this.numberOfColumns,

          loop:false,


          pagination:{

            el:this.sliderPagination,

            type:'fraction'

          },


          navigation:{

            nextEl:this.sliderNext,

            prevEl:this.sliderPrev

          },


          focusableElements:
          'input, select, option, textarea, button, video, label'


        }

      );


    slider.init();



    const focusableElements =
      FoxTheme.a11y.getFocusableElements(
        this
      );



    focusableElements.forEach(element=>{


      element.addEventListener(
        'focusin',
        function(){

          const slide =
            element.closest(
              '.swiper-slide'
            );


          if(slide){

            slider.slider.slideTo(
              slider.slider.slides.indexOf(slide)
            );

          }


        }
      );


    });


  }


}


customElements.define(
  'menu-product-list',
  MenuProductList
);




/*==================================================
PEGGRID CUSTOMER ACCOUNT DRAWER
==================================================*/

class HeaderAccount extends HTMLElement {
  connectedCallback() {
    this.account = this.querySelector('shopify-account');

    if (!this.account) return;

    try {
      sessionStorage.removeItem(
        'pg-account-refresh-after-logout'
      );
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }

    this.setupAccountDrawer(this.account);
  }

  disconnectedCallback() {
    this.accountObserver?.disconnect();
    this.dialogObserver?.disconnect();

    if (this.accountFrame) {
      cancelAnimationFrame(this.accountFrame);
    }

    if (this.accountOpenTimer) {
      clearTimeout(this.accountOpenTimer);
    }

    this.unbindAccountTrigger();
    this.unbindAccountTouchIsolation();
    this.unbindAccountClose();
    this.unbindAccountEscape();

    this.accountObserver = null;
    this.dialogObserver = null;
    this.observedDialog = null;
    this.observedLoginSlot = null;
    this.accountFrame = null;
    this.accountOpenTimer = null;
    this.account = null;
  }

  setupAccountDrawer(account) {
    const connectToShadowRoot = () => {
      if (!this.isConnected) return;

      const shadow = account.shadowRoot;

      if (!shadow) {
        this.accountFrame = requestAnimationFrame(connectToShadowRoot);
        return;
      }

      this.accountFrame = null;
      this.applyAccountDrawer(account, shadow);

      this.accountObserver?.disconnect();
      this.accountObserver = new MutationObserver(() => {
        this.applyAccountDrawer(account, shadow);
      });

      this.accountObserver.observe(shadow, {
        childList: true,
        subtree: true,
      });
    };

    connectToShadowRoot();
  }

  applyAccountDrawer(account, shadow = account.shadowRoot) {
    if (!shadow) return;

    this.bindAccountTouchIsolation(account);
    shadow.querySelector('#custom-account-styles')?.remove();

    const stylesheetUrl = this.dataset.accountStylesheet;
    const existingStylesheet = shadow.querySelector(
      'link[data-pg-account-styles]'
    );

    if (stylesheetUrl && !existingStylesheet) {
      const stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = stylesheetUrl;
      stylesheet.dataset.pgAccountStyles = '';
      shadow.prepend(stylesheet);
    }

    const dialog = shadow.querySelector('dialog');

    if (!dialog) return;

    dialog.setAttribute('aria-modal', 'true');

    this.bindAccountClose(dialog);
    this.bindAccountEscape(dialog);
    this.bindAccountTrigger(account, dialog, shadow);

    const loginSlot = dialog.querySelector(
      '.account__login-slot'
    );

    if (this.observedLoginSlot !== loginSlot) {
      this.dialogObserver?.disconnect();
      this.dialogObserver = null;
      this.observedLoginSlot = loginSlot;

      if (loginSlot) {
        this.dialogObserver = new MutationObserver(() => {
          if (this.isConnected) {
            this.ensureAccountSignOut(dialog);
          }
        });

        this.dialogObserver.observe(loginSlot, {
          attributes: true,
          attributeFilter: ['hidden'],
        });
      }
    }

    this.ensureAccountSignOut(dialog);
  }

  ensureAccountSignOut(dialog) {
    const loginSlot = dialog.querySelector(
      '.account__login-slot'
    );
    const responsiveAccountViewport = window.matchMedia(
      '(max-width: 989px), (max-width: 1366px) and (any-pointer: coarse)'
    ).matches;
    const nativeAvatar = dialog.getRootNode().querySelector(
      '.account-button__avatar, .account-button__avatar-image'
    );
    const authenticated = loginSlot
      ? (
          loginSlot.hidden &&
          (
            !responsiveAccountViewport ||
            Boolean(nativeAvatar)
          )
        )
      : this.dataset.accountAuthenticated === 'true';
    const logoutUrl =
      this.dataset.accountLogoutUrl || '/account/logout';
    const logoutPath = new URL(
      logoutUrl,
      window.location.origin
    ).pathname
      .replace(/\/+$/, '')
      .toLowerCase();

    const logoutLinks = Array.from(
      dialog.querySelectorAll('a[href]')
    ).filter(link => {
      try {
        const path = new URL(
          link.href,
          window.location.origin
        ).pathname
          .replace(/\/+$/, '')
          .toLowerCase();

        return (
          path === logoutPath ||
          path.endsWith('/account/logout') ||
          path.endsWith('/customer_identity/logout')
        );
      } catch (error) {
        return false;
      }
    });

    /*
     * Remove the legacy generated fallback before choosing the
     * configured menu row. Shopify can hydrate its native logout
     * action after the menu, so generating another row creates a
     * race that can expose two Sign Out actions.
     */
    logoutLinks
      .filter(link =>
        link.hasAttribute('data-pg-account-sign-out')
      )
      .forEach(link => {
        link.closest('.account__item-wrapper')?.remove();
      });

    const nativeLogoutLinks = logoutLinks.filter(
      link =>
        !link.hasAttribute('data-pg-account-sign-out') &&
        link.isConnected
    );
    const menuLogoutLink = nativeLogoutLinks.find(link =>
      link.closest(
        '.account__shortcuts, .account__menu-items, .account__menu-region'
      )
    );

    nativeLogoutLinks.forEach(link => {
      const wrapper = link.closest(
        '.account__item-wrapper'
      );
      const visible =
        authenticated && link === menuLogoutLink;

      if (wrapper) {
        wrapper.hidden = !visible;
        wrapper.classList.toggle(
          'pg-account-signout-wrapper',
          visible
        );

        if (visible) {
          wrapper.style.removeProperty('display');
        } else {
          wrapper.style.setProperty(
            'display',
            'none',
            'important'
          );
        }
      }

      link.classList.toggle(
        'pg-account-signout',
        visible
      );

      if (visible) {
        link.removeAttribute('aria-hidden');
        link.removeAttribute('tabindex');
      } else {
        link.setAttribute('aria-hidden', 'true');
        link.tabIndex = -1;
      }
    });
  }

  isResponsiveAccountViewport() {
    return window.matchMedia(
      '(max-width: 989px), (max-width: 1366px) and (any-pointer: coarse)'
    ).matches;
  }

  unbindAccountTouchIsolation() {
    if (this.accountTouchTarget && this.onAccountTouchEnd) {
      this.accountTouchTarget.removeEventListener(
        'touchend',
        this.onAccountTouchEnd
      );
    }

    this.accountTouchTarget = null;
    this.onAccountTouchEnd = null;
  }

  bindAccountTouchIsolation() {
    this.unbindAccountTouchIsolation();
  }

  unbindAccountTrigger() {
    if (this.accountTriggerTarget && this.onAccountPointerUp) {
      this.accountTriggerTarget.removeEventListener(
        'pointerup',
        this.onAccountPointerUp
      );
    }

    this.accountTriggerTarget = null;
    this.accountTriggerDialog = null;
    this.onAccountPointerUp = null;
  }

  bindAccountTrigger(account, dialog, shadow) {
    if (this.isResponsiveAccountViewport()) {
      this.unbindAccountTrigger();
      return;
    }

    if (
      this.accountTriggerTarget === account &&
      this.accountTriggerDialog === dialog
    ) {
      return;
    }

    this.unbindAccountTrigger();
    this.accountTriggerTarget = account;
    this.accountTriggerDialog = dialog;

    this.onAccountPointerUp = event => {
      const isTouchPointer =
        event.pointerType === 'touch' ||
        event.pointerType === 'pen';

      if (isTouchPointer) return;

      const path =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];

      const cameFromDialog = path.some(node =>
        node === dialog ||
        (
          node instanceof Node &&
          dialog.contains(node)
        )
      );

      if (
        cameFromDialog ||
        dialog.open ||
        this.accountOpenTimer ||
        (
          typeof event.button === 'number' &&
          event.button !== 0
        )
      ) {
        return;
      }

      /*
       * Give Shopify's own account control time to open the
       * drawer. If a genuine tap is dropped, retry Shopify's
       * native button once. Never call showModal directly:
       * doing so can display the drawer before Shopify has
       * prepared login and account actions.
       */
      this.accountOpenTimer = setTimeout(() => {
        this.accountOpenTimer = null;

        if (dialog.open || !this.isConnected) return;

        const nativeButton = shadow.querySelector(
          '#shopify-element-wrapper > button, .account-button, button'
        );

        nativeButton?.click();
      }, 180);
    };

    account.addEventListener(
      'pointerup',
      this.onAccountPointerUp
    );
  }

  unbindAccountClose() {
    if (this.accountCloseButton && this.onAccountClosePointerUp) {
      this.accountCloseButton.removeEventListener(
        'pointerup',
        this.onAccountClosePointerUp
      );
    }

    this.accountCloseButton = null;
    this.onAccountClosePointerUp = null;
  }

  bindAccountClose() {
    /*
     * Shopify's native close control owns dialog teardown,
     * scroll-lock removal and focus restoration. Do not call
     * dialog.close() from pointer events.
     */
    this.unbindAccountClose();
  }

  unbindAccountEscape() {
    if (this.accountEscapeDialog && this.onAccountEscape) {
      this.accountEscapeDialog.removeEventListener(
        'keydown',
        this.onAccountEscape,
        true
      );
    }

    this.accountEscapeDialog = null;
    this.onAccountEscape = null;
  }

  bindAccountEscape() {
    /*
     * Preserve Shopify's native Escape lifecycle for the same
     * scroll-lock and focus cleanup as its close button.
     */
    this.unbindAccountEscape();
  }
}

customElements.define(
  'header-account',
  HeaderAccount
);


/*==================================================
PEGGRID MOBILE DRAWER LINK TAP SAFEGUARD
==================================================*/

class PegGridMobileDrawerLinks {

  constructor() {

    this.pointer = null;

    this.lastNavigation = null;

    this.handlePointerDown =
      this.handlePointerDown.bind(this);

    this.handlePointerUp =
      this.handlePointerUp.bind(this);

    this.handlePointerCancel =
      this.handlePointerCancel.bind(this);

    this.handleClick =
      this.handleClick.bind(this);

    document.addEventListener(
      'pointerdown',
      this.handlePointerDown,
      true
    );

    document.addEventListener(
      'pointerup',
      this.handlePointerUp,
      true
    );

    document.addEventListener(
      'pointercancel',
      this.handlePointerCancel,
      true
    );

    document.addEventListener(
      'click',
      this.handleClick,
      true
    );

  }


  isMobile() {

    return window.matchMedia(
      '(max-width: 749px)'
    ).matches;

  }


  getPath(event) {

    if (
      typeof event.composedPath ===
        'function'
    ) {

      return event.composedPath();

    }

    const path = [];

    let node = event.target;

    while (node) {

      path.push(node);

      node =
        node.parentNode ||
        node.host;

    }

    path.push(window);

    return path;

  }


  getAnchor(event) {

    return this.getPath(event).find(
      node =>
        node &&
        node.nodeType === 1 &&
        String(
          node.tagName
        ).toLowerCase() === 'a' &&
        typeof node.hasAttribute ===
          'function' &&
        node.hasAttribute('href')
    );

  }


  isSupportedDrawer(path) {

    return path.some(node => {

      if (
        !node ||
        node.nodeType !== 1
      ) {

        return false;

      }

      const tagName =
        String(
          node.tagName || ''
        ).toLowerCase();

      const classes =
        node.classList;

      return (
        node.id === 'SearchDrawer' ||
        node.id === 'MenuDrawer' ||
        Boolean(
          classes &&
          (
            classes.contains(
              'search-drawer'
            )
          )
        )
      );

    });

  }


  getNavigableHref(
    anchor,
    event
  ) {

    const href =
      anchor &&
      anchor.getAttribute('href');

    if (
      !href ||
      href.startsWith('#') ||
      href.toLowerCase().startsWith(
        'javascript:'
      ) ||
      anchor.hasAttribute('download') ||
      (
        anchor.target &&
        anchor.target !== '_self'
      ) ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (
        typeof event.button ===
          'number' &&
        event.button !== 0
      )
    ) {

      return null;

    }

    return anchor.href;

  }


  navigate(
    anchor,
    event
  ) {

    const href =
      this.getNavigableHref(
        anchor,
        event
      );

    if (!href) return;

    const now = Date.now();

    if (
      this.lastNavigation &&
      this.lastNavigation.href === href &&
      now - this.lastNavigation.time < 900
    ) {

      return;

    }

    this.lastNavigation = {
      href,
      time:now
    };

    event.preventDefault();
    event.stopPropagation();

    window.location.assign(href);

  }


  handlePointerDown(event) {

    if (!this.isMobile()) {

      return;

    }

    const path =
      this.getPath(event);

    const anchor =
      this.getAnchor(event);

    if (
      !anchor ||
      !this.isSupportedDrawer(path)
    ) {

      this.pointer = null;
      return;

    }

    this.pointer = {
      anchor,
      x:event.clientX,
      y:event.clientY,
      pointerId:event.pointerId
    };

  }


  handlePointerUp(event) {

    if (
      !this.pointer ||
      this.pointer.pointerId !==
        event.pointerId
    ) {
      return;
    }

    const pointer =
      this.pointer;

    this.pointer = null;

    const anchor =
      this.getAnchor(event);

    if (anchor !== pointer.anchor) {
      return;
    }

    const movement =
      Math.hypot(
        event.clientX - pointer.x,
        event.clientY - pointer.y
      );

    if (movement > 14) {

      return;

    }

    this.navigate(
      anchor,
      event
    );

  }


  handleClick(event) {

    if (!this.isMobile()) return;

    const path =
      this.getPath(event);

    const anchor =
      this.getAnchor(event);

    if (
      !anchor ||
      !this.isSupportedDrawer(path)
    ) {

      return;

    }

    this.navigate(
      anchor,
      event
    );

  }


  handlePointerCancel() {

    this.pointer = null;

  }

}


if (!window.PegGridMobileDrawerLinksController) {
  window.PegGridMobileDrawerLinksController =
    new PegGridMobileDrawerLinks();
}
